import {Injectable} from '@angular/core';

/**
 * Translations for campaign activity.
 */
@Injectable()
export class CampaignActivityTranslationService {
  public i18nMailSend: any = $localize`:@@general.text.mailSend:Mail send`;
  public i18nLinkClick: any = $localize`:@@general.text.mailClick:Link click`;
  public i18nMailBounce: any = $localize`:@@general.text.mailbounce:Mail bounce`;
  public i18nMailOpen: any = $localize`:@@general.text.mailOpen:Mail open`;
  public i18nUserSubscribe: any = $localize`:@@general.text.userSubscribe:User subscribe`;
  public i18nUserUnsubscribe: any = $localize`:@@general.text.userUnsubscribe:User unsubscribe`;
  public i18nUserDeactivated: any = $localize`:@@general.text.userDeactivated:User deactivated`;
  public i18nUserActivated: any = $localize`:@@general.text.userActivated:User activated`;
  constructor() { }
}
